import "./GanttTodayLine.css";

import { JSX } from "react/jsx-runtime";

import { GanttTodayLineProps } from "../../models";

/** Full-height vertical line rendered inside a position:relative row cell */
export const GanttTodayLine = ({ x }: GanttTodayLineProps): JSX.Element => (
  <div className="GanttTodayLine" style={{ left: x }} aria-hidden="true" />
);
